import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { closeModal } from '../actions';

const modal = defaults => {
    const { name } = defaults;

    return WrappedComponent => {
        class ReduxModal extends Component {
            render() {
                return (
                    <Modal ariaHideApp={false} {...defaults} {...this.props}>
                        <WrappedComponent {...this.props} />
                    </Modal>
                );
            }
        }

        const mapStateToProps = state => {
            return state.modal ? state.modal : {};
        };

        const mapDispatchToProps = (dispatch, props) => ({
            onRequestClose: () => {
                props.onRequestClose && props.onRequestClose();
                dispatch(closeModal(name));
            },
        });

        return connect(
            mapStateToProps,
            mapDispatchToProps
        )(ReduxModal);
    };
};

export default modal;



// WEBPACK FOOTER //
// ./src/ui/modal.js